import { useState } from "react";
import { Phone, Mail, MessageCircle, X } from "lucide-react";

export const ContactWidget = () => {
  const [open, setOpen] = useState(true);

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        aria-label="Open contact"
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-3 shadow-xl hover:opacity-90 transition"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="text-sm font-semibold">Contact</span>
      </button>
    );
  }

  return (
    <div className="fixed bottom-6 right-6 z-40 w-[300px] rounded-2xl border bg-background/95 backdrop-blur-sm shadow-xl overflow-hidden">
      <div className="flex items-center justify-between gap-2 bg-primary text-primary-foreground px-4 py-2.5 rounded-t-2xl">
        <div className="flex items-center gap-2">
          <MessageCircle className="h-4 w-4" />
          <span className="text-sm font-semibold">Get in touch</span>
        </div>
        <button
          onClick={() => setOpen(false)}
          aria-label="Minimize contact"
          className="rounded-full p-1 hover:bg-primary-foreground/20 transition"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex flex-col gap-2 p-4 text-sm">
        <a
          href="tel:+18588156800"
          className="flex items-center gap-2 rounded-xl bg-muted/60 hover:bg-muted px-3 py-2 text-foreground hover:text-primary transition-colors font-medium"
        >
          <Phone className="h-4 w-4 text-primary shrink-0" />
          <span>Call or text +1 858 815 6800</span>
        </a>
        <a
          href="mailto:Orders@AquaQuote.com"
          className="flex items-center gap-2 rounded-xl bg-muted/60 hover:bg-muted px-3 py-2 text-foreground hover:text-primary transition-colors font-medium"
        >
          <Mail className="h-4 w-4 text-primary shrink-0" />
          <span>Orders@AquaQuote.com</span>
        </a>
      </div>
    </div>
  );
};
